import React from 'react'

function Favourite() {
	return (
		<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.89361 1.67002L4.04502 1.83519L4.21019 1.68378C4.66441 1.22957 5.31132 1.0231 5.93071 1.13322C6.88044 1.28462 7.58241 2.11047 7.58241 3.07396V3.14278C7.58241 3.72088 7.33465 4.27145 6.92173 4.65684L4.43042 6.98299C4.33407 7.07934 4.19642 7.12063 4.05878 7.12063C3.90738 7.12063 3.76974 7.07934 3.67339 6.98299L1.18207 4.65684C0.769147 4.27145 0.535156 3.72088 0.535156 3.14278V3.07396C0.535156 2.11047 1.22336 1.28462 2.17309 1.13322C2.79248 1.0231 3.4394 1.22957 3.89361 1.67002C3.89361 1.68378 3.87985 1.67002 3.89361 1.67002ZM4.04502 2.77115L3.42563 2.138C3.12282 1.84895 2.69613 1.71131 2.28321 1.78013C1.65005 1.89025 1.19584 2.42705 1.19584 3.07396V3.14278C1.19584 3.54195 1.34724 3.91358 1.63629 4.1751L4.05878 6.43242L6.46751 4.1751C6.75656 3.91358 6.92173 3.54195 6.92173 3.14278V3.07396C6.92173 2.42705 6.45375 1.89025 5.8206 1.78013C5.40767 1.71131 4.98098 1.84895 4.67817 2.138L4.04502 2.77115Z"
				fill="#F9F9FB"
			/>
		</svg>
	)
}

export default Favourite
